import React from "react";

/**
 * KittingTrayIcon — state-aware isometric tray.
 *   "pending"  → minimalist empty grey tray
 *   "complete" → green tray with 2 silver cylinders + 1 cube (cut raw material)
 *   default    → legacy full-colour blue variant (release-notes legend)
 */
export default function KittingTrayIcon({ size = 14, state, className = "" }) {
  const s = size;
  const baseProps = {
    width: s * 1.3,
    height: s,
    viewBox: "0 0 18 14",
    className,
    "aria-hidden": "true",
  };

  if (state === "pending") {
    return (
      <svg {...baseProps}>
        {/* Empty tray back */}
        <path
          d="M2 10 L4 6 L14 6 L16 10 Z"
          fill="#e2e8f0"
          stroke="#94a3b8"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        {/* Empty tray front lip */}
        <path
          d="M2 10 L3 13 L15 13 L16 10 Z"
          fill="#cbd5e1"
          stroke="#94a3b8"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (state === "complete") {
    return (
      <svg {...baseProps}>
        {/* Tray back — green */}
        <path
          d="M2 10 L4 6 L14 6 L16 10 Z"
          fill="#059669"
          stroke="#064e3b"
          strokeWidth="0.4"
          strokeLinejoin="round"
        />
        {/* Tray front lip — brighter green */}
        <path
          d="M2 10 L3 13 L15 13 L16 10 Z"
          fill="#10b981"
          stroke="#064e3b"
          strokeWidth="0.4"
          strokeLinejoin="round"
        />
        {/* Silver cylinder 1 */}
        <g>
          <rect x="4.4" y="4.2" width="2" height="3.8" fill="#cbd5e1" />
          <ellipse cx="5.4" cy="4.2" rx="1" ry="0.4" fill="#f1f5f9" stroke="#64748b" strokeWidth="0.25" />
          <ellipse cx="5.4" cy="8" rx="1" ry="0.4" fill="#94a3b8" stroke="#475569" strokeWidth="0.25" />
        </g>
        {/* Silver cylinder 2 */}
        <g>
          <rect x="7.5" y="3.8" width="2" height="4.2" fill="#cbd5e1" />
          <ellipse cx="8.5" cy="3.8" rx="1" ry="0.4" fill="#f1f5f9" stroke="#64748b" strokeWidth="0.25" />
          <ellipse cx="8.5" cy="8" rx="1" ry="0.4" fill="#94a3b8" stroke="#475569" strokeWidth="0.25" />
        </g>
        {/* Cube (cut raw material) — diagonal top + side faces for iso look */}
        <g>
          <polygon points="11,5.5 12.5,4.8 14,5.5 12.5,6.2" fill="#e2e8f0" stroke="#475569" strokeWidth="0.3" />
          <polygon points="11,5.5 12.5,6.2 12.5,8.4 11,7.7" fill="#cbd5e1" stroke="#475569" strokeWidth="0.3" />
          <polygon points="14,5.5 12.5,6.2 12.5,8.4 14,7.7" fill="#94a3b8" stroke="#475569" strokeWidth="0.3" />
        </g>
      </svg>
    );
  }

  /* Fallback — legacy full-colour blue tray for legends */
  return (
    <svg {...baseProps}>
      <path d="M2 10 L4 6 L14 6 L16 10 Z" fill="#1e40af" stroke="#0f172a" strokeWidth="0.4" strokeLinejoin="round" />
      <path d="M2 10 L3 13 L15 13 L16 10 Z" fill="#2563eb" stroke="#0f172a" strokeWidth="0.4" strokeLinejoin="round" />
      {[5, 9, 12.5].map((cx) => (
        <g key={cx}>
          <rect x={cx - 1.1} y="4" width="2.2" height="4" fill="#cbd5e1" />
          <ellipse cx={cx} cy="4" rx="1.1" ry="0.45" fill="#f1f5f9" stroke="#64748b" strokeWidth="0.25" />
          <ellipse cx={cx} cy="8" rx="1.1" ry="0.45" fill="#94a3b8" stroke="#475569" strokeWidth="0.25" />
        </g>
      ))}
    </svg>
  );
}
